import React, { useState, useEffect } from 'react';
import { monthlyUpdates } from '../components/Pulse';
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import '../index.css';
import '../css/PulseReleasePage.css';

export default function PulseUpdatesPage() {
  const [visibleCount, setVisibleCount] = useState(1);

  const loadMore = () => {
    setVisibleCount(c => Math.min(monthlyUpdates.length, c + 1));
  };

  useEffect(() => {
    const galleries = document.querySelectorAll('.pulse-gallery, .forensics-gallery');
    if (!galleries.length) return;

    const cleanupFns = [];

    galleries.forEach((gallery) => {
      const pills = Array.from(gallery.querySelectorAll('.pulse-gallery-pill, .f-pill'));
      const panels = Array.from(gallery.querySelectorAll('.pulse-gallery-panel, .f-panel'));
      const radios = Array.from(gallery.querySelectorAll('input[type="radio"]'));

      const slideCount = Math.max(pills.length, panels.length, radios.length);
      if (slideCount <= 1) return;

      let isPaused = false;
      const intervalMs = parseInt(gallery.getAttribute('data-interval') || '4500', 10);

      const setActiveIndex = (index) => {
        if (pills.length) {
          pills.forEach((p, idx) => p.classList.toggle('active', idx === index));
        }
        if (panels.length) {
          panels.forEach((p, idx) => p.classList.toggle('active', idx === index));
        }
        if (radios.length && radios[index]) {
          radios[index].checked = true;
        }
      };

      // Determine initial active index
      let currentIndex = 0;
      if (radios.length) {
        const checkedIdx = radios.findIndex(r => r.checked);
        if (checkedIdx >= 0) currentIndex = checkedIdx;
      } else if (pills.length) {
        const activeIdx = pills.findIndex(p => p.classList.contains('active'));
        if (activeIdx >= 0) currentIndex = activeIdx;
        else setActiveIndex(0);
      }

      // Hover to pause
      const onMouseEnter = () => { isPaused = true; };
      const onMouseLeave = () => { isPaused = false; };
      gallery.addEventListener('mouseenter', onMouseEnter);
      gallery.addEventListener('mouseleave', onMouseLeave);

      // Pill click handling
      const onGalleryClick = (e) => {
        const pill = e.target.closest('.pulse-gallery-pill, .f-pill');
        if (pill) {
          const idx = pills.indexOf(pill);
          if (idx >= 0) {
            currentIndex = idx;
            setActiveIndex(idx);
            return;
          }
        }

        // Image box click to advance
        if (e.target.closest('.pulse-gallery-box, .forensics-img-box')) {
          currentIndex = (currentIndex + 1) % slideCount;
          setActiveIndex(currentIndex);
        }
      };
      gallery.addEventListener('click', onGalleryClick);

      // Auto-cycle timer
      const timer = setInterval(() => {
        if (isPaused) return;
        if (!document.contains(gallery)) return;

        currentIndex = (currentIndex + 1) % slideCount;
        setActiveIndex(currentIndex);
      }, intervalMs);

      cleanupFns.push(() => {
        clearInterval(timer);
        gallery.removeEventListener('mouseenter', onMouseEnter);
        gallery.removeEventListener('mouseleave', onMouseLeave);
        gallery.removeEventListener('click', onGalleryClick);
      });
    });

    return () => {
      cleanupFns.forEach(fn => fn());
    };
  }, [visibleCount]);

  return (
    <div className="pulse-flex-root">
      <div className="pulse-center-container">
        <header className="pulse-header">
          <Nav />
          <div className="pulse-hero">
            <h1>The Pulse</h1>
            <p>Your community update for ProductionRP</p>
          </div>
        </header>

        <div className="pulse-body">
          {monthlyUpdates
            .slice(0, visibleCount)
            .map(({ id, monthLabel, content }) => (
              <section key={id} className="pulse-month-section">
                <div className="pulse-month-label">{monthLabel}</div>
                <div dangerouslySetInnerHTML={{ __html: content }} />
              </section>
            ))}
          {visibleCount < monthlyUpdates.length
            ? <div className="pulse-load-more-row">
              <button onClick={loadMore} className="pulse-load-more-btn">
                Load more updates
              </button>
            </div>
            : <p style={{ textAlign: 'center' }}><b>No more updates</b></p>
          }
        </div>
      </div>
      <Footer />
    </div>
  );
}
